module.exports = __webpack_public_path__ + "img/student-header-illustration.69cb3dca.svg";